<div class="card-body autopass-container">

    <div class="row">

        <div class="ap-flex" *ngIf="filter">
            <h2>{{ filter?.ClientCode }}</h2>     

            <div>
              <label>FILTER NAME </label>
              <input type="text" [(ngModel)]="filter.FilterName" />
            </div>

            <div>
              <label>PRIORITY </label>
              <input type="text" [(ngModel)]="filter.Priority" />
            </div>        
        </div>
      
        <!-- <app-ct-query-builder (onfilter)="onfetchMore($event)" (onSearch)="onSearch($event)" (resetPage)="resetPage()"  class="margin30" [data]="query" [config]="config"  (fileChange)="onFileChange($event)" (exportExcel)="onExportExcel($event)">
        </app-ct-query-builder> -->

        <query-builder  id="queryBuilder"
          (onfilter)="onfetchMoreData($event)"
          [formControl]='queryCtrl' 
          [config]='config' 
          [allowRuleset]='allowRuleset' 
          [allowCollapse]='allowCollapse'  
          [DataTypeBuilder]="dataTypeBuilder"
          [DataTypeParent]="dataTypeParent"
          [DataTypeChildren]="dataTypeChildren"
          [DefaultDataType]="DefaultDataType"
          [persistValueOnFieldChange]='persistValueOnFieldChange'>
      
            <ng-container *queryInput="let rule; type: 'textarea'; let getDisabledState=getDisabledState">
              <textarea class="text-input ct-textarea" [(ngModel)]="rule.value" [disabled]=getDisabledState() ></textarea>
            </ng-container>

            <ng-container *queryInput="let rule; type: 'currency'; let getDisabledState=getDisabledState">
              <ng-select [searchWhileComposing]="true"           
                  [searchable]="true"
                  [multiple]="false"
                  [clearSearchOnAdd]="true"
                  [loading]="loading"
                  [virtualScroll]="true"  
                  [(ngModel)]="rule.value"
                  class="currency-list">
                  <ng-option *ngFor="let list of listsCurrency"  [value]="list.name">{{list.name}}</ng-option>              
              </ng-select>
            </ng-container>

            <ng-container *queryInput="let rule; type: 'multiple-custom-invoice-status'; let getDisabledState=getDisabledState">
              <ng-select [searchWhileComposing]="false"           
                  [searchable]="true"
                  [multiple]="true"
                  [clearSearchOnAdd]="true"
                  [loading]="loading"
                  [virtualScroll]="true"  
                  [(ngModel)]="rule.value"
                  class="multiple-list">
                  <ng-option *ngFor="let list of config?.fields['invoicestatusvalidatelist']['options']"  [value]="list.value">{{list.name}}</ng-option>              
              </ng-select>
            </ng-container>

            <ng-container *queryInput="let rule; type: 'invoicesource'; let getDisabledState=getDisabledState">
              <ng-select [searchWhileComposing]="true"           
                  [searchable]="true"
                  [multiple]="true"
                  [clearSearchOnAdd]="true"
                  [loading]="loading"
                  [virtualScroll]="true"  
                  [(ngModel)]="rule.value"
                  class="invoice-source-list"
                  bindLabel="value">
                  <ng-option *ngFor="let list of listsInvoiceSource"  [value]="list.value">{{list.name}}</ng-option>              
              </ng-select>
            </ng-container>

            <ng-container *queryInput="let rule; type: 'reasoncode'; let getDisabledState=getDisabledState">
              <ng-select [searchWhileComposing]="true"           
                  [searchable]="true"
                  [multiple]="false"
                  [clearSearchOnAdd]="true"
                  [loading]="loading"
                  [virtualScroll]="true"  
                  [(ngModel)]="rule.value"
                  (scrollToEnd)="onfetchMoreReasonCodes()"
                  class="currency-list">
                  <ng-option *ngFor="let list of listsReasonCodes"  [value]="list.name">{{list.name}}</ng-option>              
              </ng-select>
            </ng-container>

      </query-builder>
      
      <!-- <pre>
        {{ queryNew | json }}
      </pre> -->

    </div>

    <div class="row bottom-controls">
       <div class="apf-controls">
          <button id="autopsaveasnew" class="ctgfa-btn ctgfa-confirm-btn" (click)="saveAsNew(queryNew)"> <i class="fa fa-save"></i> Save As New</button>
          <button id="autopsave" class="ctgfa-btn ctgfa-primary-btn" (click)="saveAutopass(queryNew)"> <i class="fa fa-save"></i> Save</button>
       </div>
    </div>

</div>

<!-- uncoment to check the query data -->
<!-- <textarea style="width:1000px;height:500px" >{{query | json}}</textarea> -->

<!-- <div style="margin-right: 10px;padding-bottom: 15px;">
    <button kendoButton (click)="saveAutopass(queryNew)" style="float: right;margin: 2px;" class="ct-freight_btn-primary btn-info.btn-outline:hover k-button k-primary"> <i class="fa fa-save"></i> Save</button>
    <button kendoButton (click)="saveAsFilter()" style="float: right;margin: 2px;" class="ct-freight_btn-primary btn-info.btn-outline:hover k-button k-primary"> <i class="fa fa-save"></i> Save As New</button>
</div> -->

  <hr>
<div>
  <!-- <app-rule-properties [desc]="'autopass'" (onFetch)="onfetchProperties()" [ruleLeft]="ruleLeft" [ruleRight]="ruleRight" (appliedSaveEvent)="onSaveAppliedRule($event)" (propertiesSaveEvent)="onSaveProperties($event)" (dropDownListPropEvent)="onChangeDropDownProp($event)" ></app-rule-properties> -->
</div>